module.exports = __webpack_public_path__ + "d0e7572edfa2036664b94a8bfa5565b5.jpg";